<template>
    <v-card>
        <loading-component :value="loading"></loading-component>
        <v-form ref="personal_info_form">
            <v-container :fluid="true" style="padding:0">
                <v-layout row wrap>
                    <v-flex xs4>
                        <div class="px-3">
                            <v-layout row>
                                <v-flex xs12>
                                    <v-text-field :rules="requiredRules" label="First Name"
                                                  v-model="passenger.first_name"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout class="mt-5" row>
                                <v-flex xs12>
                                    <v-text-field :rules="requiredRules" label="Last Name"
                                                  v-model="passenger.last_name"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout class="mt-5" row>
                                <v-flex xs12>
                                    <v-text-field :rules="numberRules" label="Whatsapp(country code required)"
                                                  v-model="passenger.whatsapp_number"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout class="mt-5" row>
                                <v-flex xs5>
                                    <b>Username</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{passenger.username}}
                                </v-flex>
                            </v-layout>
                            <v-layout class="mt-5" row>
                                <v-flex xs5>
                                    <b>Email</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{passenger.email}}
                                </v-flex>
                            </v-layout>
                            <v-layout class="mt-5" row>
                                <v-flex xs5>
                                    <b>Created At</b>
                                </v-flex>
                                <v-flex xs7>
                                    {{ formatCompanyTime(passenger.created_at, 'DD MMM YYYY') }}
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                    <v-layout row wrap>
                        <v-flex xs6>
                            <div class="px-3">
                                <v-img
                                        style="cursor: pointer"
                                        :src="files.id_card_front.url ? files.id_card_front.url : api.GET_IMAGE(passenger.id_card_front)"
                                        @click="openImage(files.id_card_front.url ? files.id_card_front.url : api.GET_IMAGE(passenger.id_card_front))"
                                        width="60%"
                                        v-if="files.id_card_front.url || passenger.id_card_front"></v-img>
                                <v-text-field label="Upload ID Card front-face" @click='$refs.id_card_front.click()'
                                              v-model='files.id_card_front.name' :rules="fileRules"
                                              append-icon='attach_file'
                                              readonly></v-text-field>
                                <input type="file" style="display: none" ref="id_card_front"
                                       accept="image/*" @change="onFilePicked('id_card_front')">
                            </div>
                        </v-flex>
                        <v-flex xs6>
                            <div class="px-3">
                                <v-img
                                        style="cursor: pointer"
                                        @click="openImage(files.id_card_back.url ? files.id_card_back.url : api.GET_IMAGE(passenger.id_card_back))"
                                        :src="files.id_card_back.url ? files.id_card_back.url : api.GET_IMAGE(passenger.id_card_back)"
                                        width="60%"
                                        v-if="files.id_card_back.url || passenger.id_card_back"></v-img>
                                <v-text-field label="Upload ID Card back-face" @click='$refs.id_card_back.click()'
                                              v-model='files.id_card_back.name' :rules="fileRules"
                                              append-icon='attach_file'
                                              readonly></v-text-field>
                                <input type="file" style="display: none" ref="id_card_back"
                                       accept="image/*" @change="onFilePicked('id_card_back')">
                            </div>
                        </v-flex>
                        <v-btn :disabled="!passenger.id_card_front && !passenger.id_card_back" @click="dialog = true"
                               center color="red" style="width: 100%">Remove Docs and notify to
                            upload again
                        </v-btn>
                    </v-layout>
                </v-layout>
            </v-container>
        </v-form>
        <v-dialog v-model="image_dialog">
            <img :src="selected_file" style="width: 100%" v-if="selected_file"/>
        </v-dialog>
        <v-dialog v-model="dialog" width="350px">
            <v-card>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-select
                                :rules="requiredRules"
                                :items="['العمر تحت السن القانوني', 'وثيقة منتهية الصلاحية', 'رافع فقط وجه واحد', 'احد الوجهين غير واضح', 'اسم الحساب غير مطابق للاسم بالوثيقة', 'صور هوية خاطئة']"
                                label="Message"
                                v-model="message"
                        ></v-select>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="removeDocs">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "PersonalInfo",
        components: {LoadingComponent},
        data() {
            return {
                dialog: false,
                valid: false,
                message: '',
                image_dialog: false,
                selected_file: null,
                loading: false,
                passenger: {},
                files: {
                    id_card_front: {},
                    id_card_back: {}
                },
                fileRules: [
                    v => !!v || 'File is required',
                ],
                numberRules: [
                    v => !!v || 'Required field',
                ],
                requiredRules: [
                    v => !!v || 'Field is required'
                ],
                passenger_id: null
            }
        },
        watch: {
            image_dialog(val) {
                if (!val) {
                    this.selected_file = null;
                }
            }
        },
        methods: {
            removeDocs() {
                if (!this.$refs.form.validate()) {
                    return;
                }
                this.loading = true;
                this.axios.put(`passenger/${this.passenger.id}/remove_documents` + (this.message === 'العمر تحت السن القانوني' ? '?no_approval=true' : ''), {message: this.message})
                    .then((res) => {
                        this.status = res.data.data;
                        this.files = {
                            id_card_front: {},
                            id_card_back: {}
                        };
                        this.$set(this.passenger, 'id_card_front', null);
                        this.$set(this.passenger, 'id_card_back', null);
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => {
                        this.loading = false;
                        this.dialog = false;
                    });
            },
            openImage(selected_image) {
                this.selected_file = selected_image;
                this.image_dialog = true;
            },
            reset() {
                this.passenger = {};
                this.files = {
                    id_card_front: {},
                    id_card_back: {}
                };
                this.$refs.personal_info_form.reset();
            },
            update(passenger_id) {
                this.reset();
                this.passenger_id = passenger_id;
                this.loading = true;
                this.axios.get(`passenger/${passenger_id}`)
                    .then(res => {
                        this.passenger = res.data.data;
                        if (this.passenger.id_card_front) {
                            this.files.id_card_front = {name: 'ID Card front'};
                        }
                        if (this.passenger.id_card_back) {
                            this.files.id_card_back = {name: 'ID Card back'};
                        }
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            async submit() {
                const formData = new FormData();

                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };

                if (!this.$refs.personal_info_form.validate()) {
                    return;
                }

                this.loading = true;

                if (this.files.id_card_front.changed) {
                    formData.append('id_card_front', this.files.id_card_front.file);
                }
                if (this.files.id_card_back.changed) {
                    formData.append('id_card_back', this.files.id_card_back.file);
                }
                formData.append('first_name', this.passenger.first_name);
                formData.append('last_name', this.passenger.last_name);
                formData.append('whatsapp_number', this.passenger.whatsapp_number);
                formData.append('_method', 'PUT');
                await this.axios.post(`passenger/${this.passenger_id}`, formData, config)
                    .then(() => {
                        this.$emit('next_step');
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    });
                this.loading = false;
            },
            onFilePicked(type) {
                const files = this.$refs[type].files;
                if (files[0] !== undefined) {
                    this.files[type].changed = true;
                    this.files[type].name = files[0].name;
                    if (this.files[type].name.lastIndexOf('.') <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.$set(this.files[type], 'url', fr.result);
                        // this.files[type].url = fr.result;
                        this.files[type].file = files[0];
                    })
                } else {
                    this.files[type] = {};
                }
            },
        }
    }
</script>

<style scoped>

</style>